import React, { useState } from 'react';
import { BasicPageContainer } from "components/views/BasicPageContainer";
import { Tab, Tabs } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AuthGuard from 'context/auth/AuthGuard';
import { UserRoles } from 'constants/userRoles';
import { GeneralSettingsTab } from './GeneralSettingsTab';
import { GogglesTab } from './GogglesTab';

enum WorkspaceManagementTab {
    General = 0,
    Goggles = 1
}

export const WorkspaceManagementPage = () => {
    const { t } = useTranslation();
    const [selectedTab, setSelectedTab] = useState<WorkspaceManagementTab>(WorkspaceManagementTab.General);

    return (
        <AuthGuard requiredRoles={[UserRoles.ADMIN]}>
            <BasicPageContainer>
                <Tabs
                    value={selectedTab}
                    onChange={(_, value) => setSelectedTab(value as WorkspaceManagementTab)}
                    indicatorColor="primary"
                    textColor="primary"
                    aria-label="Workspace management tabs"
                    sx={{ mt: -6, mb: 4, borderBottom: 1, borderColor: 'divider' }}
                >
                    <Tab label={t('workspaceManagement.generalTab')} data-testid="workspace-general-tab" />
                    <Tab label={t('workspaceManagement.gogglesTab')} data-testid="workspace-goggles-tab" />
                </Tabs>
                {selectedTab === WorkspaceManagementTab.General ? <GeneralSettingsTab /> : <GogglesTab />}
            </BasicPageContainer>
        </AuthGuard>
    );
};
